import type { ReactNode } from 'react';
import { useParams } from 'react-router';
import Page404 from './Page404';

const validTypes = ['pressreleases', 'news', 'blog_posts', 'events', 'documents', 'videos'];
const validTypesWithImages = [...validTypes, 'images'];

export const ValidateMaterialType = ({
  renderChildrenOnMissingParam = false,
  children,
  includeImages = false,
}: {
  renderChildrenOnMissingParam?: boolean;
  includeImages?: boolean;
  children: ReactNode;
}) => {
  const params = useParams();
  const type = params.materialType;
  if (!type && renderChildrenOnMissingParam) {
    return <>{children}</>;
  }
  if (!type || !(includeImages ? validTypesWithImages : validTypes).includes(type)) {
    return <Page404 />;
  }
  return <>{children}</>;
};
